import { supabase } from '@/integrations/supabase/client';

export type NewsletterSignupStatus = 'pending' | 'already_confirmed';

export const NEWSLETTER_SOURCE_SECTION = 'website_newsletter_section';
export const NEWSLETTER_SOURCE_POPUP = 'website_popup_8s';
export const NEWSLETTER_SOURCE_BLOG = 'blog';

const SIGNUP_FLAG = 'newsletter_signup_completed';
const DISMISSED_AT = 'newsletter_popup_dismissed_at';

/** Shared signup call — same endpoint / DOI flow for section and popup. */
export async function signupNewsletter(
  email: string,
  language: string,
  source: string,
): Promise<NewsletterSignupStatus | null> {
  const { data, error } = await supabase.functions.invoke('newsletter-signup', {
    body: { email, language, source },
  });
  if (error) {
    console.error('[Newsletter] signup failed:', error);
    return null;
  }
  const status: NewsletterSignupStatus =
    data?.status === 'already_confirmed' ? 'already_confirmed' : 'pending';
  markNewsletterSignupCompleted();
  return status;
}

export function markNewsletterSignupCompleted(): void {
  try {
    localStorage.setItem(SIGNUP_FLAG, 'true');
  } catch {
    /* storage unavailable */
  }
}

export function hasNewsletterSignupCompleted(): boolean {
  try {
    return localStorage.getItem(SIGNUP_FLAG) === 'true';
  } catch {
    return false;
  }
}

export function markNewsletterPopupDismissed(): void {
  try {
    localStorage.setItem(DISMISSED_AT, String(Date.now()));
  } catch {
    /* storage unavailable */
  }
}

export function wasNewsletterPopupDismissedWithin(days: number): boolean {
  try {
    const raw = localStorage.getItem(DISMISSED_AT);
    if (!raw) return false;
    const ts = Number(raw);
    if (!Number.isFinite(ts)) return false;
    return Date.now() - ts < days * 24 * 60 * 60 * 1000;
  } catch {
    return false;
  }
}
